module.exports = __webpack_public_path__ + "static/img/02037D_1_R_20201124_LC.d925d8b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/02037D_1_R_20201124_LC.png
// module id = P9T/
// module chunks = 0